import {Col, Divider, Flex, Row, Tooltip} from "antd";
import dayjs from "dayjs";
import React from "react";
import {useTranslation} from "react-i18next";

export const MarkCommon = React.memo(({
                                        item,
                                        mark,
                                        index,
                                        handleClickMark,
                                        record,
                                        column
                                      }: any) => {
  const {t} = useTranslation("common")

  return (
    <Tooltip  destroyTooltipOnHide title={(
      mark.theme &&
      <Row>
        {
          mark.theme &&
          <Col span={24}>
            {t('theme')}: {mark.theme}
          </Col>
        }
        {
          mark.hours &&
          <Col span={24}>
            Часы: {mark.hours}
          </Col>
        }
        {
          mark.date_at &&
          <Col span={24}>
            {t('date')}: {dayjs(mark.date_at).format('DD.MM.YYYY')}
          </Col>
        }

      </Row>
    )}>
      <Flex
        key={`${item?.type}-button-${mark?.key}-${index}`}
        onClick={() => mark?.isEdit ? handleClickMark(mark, record, column) : {}}
        style={{
          backgroundColor: mark?.['background-color'] || 'rgba(255,255,255, 0.8)',
          cursor: mark?.isEdit ? 'pointer' : 'default',
          border: `1px solid ${mark?.['border-color'] || `#d9d9d9`}`,
          flexDirection: 'column',
          width: 50,
          height: 50,
          borderRadius: 8,
          overflow: 'hidden'
        }}
      >
        <Flex style={{backgroundColor: 'var(--c-light-hover)', height: 25}} justify='center'>
          {dayjs(mark?.date_at).format('DD.MM')}
        </Flex>
        <Divider/>
        <Flex justify='center'>
          {mark?.mark}
        </Flex>
      </Flex>
    </Tooltip>
  )
})